import React, { useEffect, useReducer } from "react";
import { ListReducer } from "../reducers/ListReducer";
import Fotter from "./Footer";
import FormMarket from "./FormMarket";
import Header from "./Header";
import ListItem from "./ListItem";

const init = () => {
  const list = localStorage.getItem("list");
  return list ? JSON.parse(list) : [];
};

const ListMarket = () => {
  const [state, dispatch] = useReducer(ListReducer, [], init);
  useEffect(() => {
    localStorage.setItem("list", JSON.stringify(state));
  }, [state]);

  return (
    <>
      <Header />
      <ListItem list={state} dispatch={dispatch} />
      <FormMarket dispatch={dispatch} />
      <Fotter />
    </>
  );
};

export default ListMarket;
